module.exports = __webpack_public_path__ + "assets/img/chongQingXuanDi.fba18d54.png";